import { allowedUserAgents } from 'constants.js';

export const isHoverableDevice = () => {
  const check = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  return check;
};

const getParentOrigin = () => {
  const locationAreDisctint = window.location !== window.parent.location;
  const parentOrigin = (
    (locationAreDisctint ? document.referrer : document.location) || ''
  ).toString();

  if (parentOrigin) {
    return new URL(parentOrigin).origin;
  }

  const currentLocation = document.location;

  if (
    currentLocation.ancestorOrigins &&
    currentLocation.ancestorOrigins.length
  ) {
    return currentLocation.ancestorOrigins[0];
  }

  return '';
};

export const getCustomUserAgent = () => {
  if (
    navigator.userAgent.indexOf('mijnZiekenhuis') >= 0 ||
    getParentOrigin().indexOf('mijnziekenhuis.be') >= 0
  ) {
    return allowedUserAgents.MHZ;
  }

  if (navigator.userAgent.indexOf('hylyghtApp') >= 0) {
    return allowedUserAgents.HY;
  }

  return null;
};

export const isMzhUserAgent = () => {
  return getCustomUserAgent() === allowedUserAgents.MHZ;
};

export const getParentUrl = () => {
  if (process.env.REACT_APP_MOBILE_DEV === 'true') {
    return 'http://localhost:3002';
  }

  const isApple =
    /iPhone|iPad|iPod/i.test(navigator.userAgent) ||
    (navigator.userAgent.includes('Mac') && 'ontouchend' in document);

  if (isApple) {
    return 'capacitor://localhost';
  } else {
    return 'https://localhost';
  }
};

export const isHylyghtAppAgent = () => {
  if (process.env.REACT_APP_MOBILE_DEV === 'true') return true;

  return getCustomUserAgent() === allowedUserAgents.HY;
};

// This is used to open direct links, like IDo exercise page
// IDoReportCard, EmptyReportCard,
// EditSessionCard, TestSessionSporterList
// SporterSession, Sporter, Overview
export const openNewWindow = url => {
  const win = window.open(url, '_blank');
  // try catch needed for some case: example firefox mobile crashes on .focus()
  try {
    win.focus();
  } catch (er) {}
};

// This is used to open PDF's with a pollIsValidUrl
export const openWindowWithLoader = (withPdf = true) => {
  return withPdf
    ? window.open('/loading/generating-pdf', '_blank')
    : window.open('/loading', '_blank');
};

export const navigateToUrl = url => {
  window.location.href = url;
};

export const getFullLocation = () => {
  const port =
    window.location.port === '80' ||
    window.location.port === '443' ||
    window.location.port === ''
      ? ''
      : `:${window.location.port}`;
  return `${window.location.protocol}//${window.location.hostname}${port}`;
};

export const isDesktopSafari = () => {
  const uA = navigator.userAgent;
  const vendor = navigator.vendor;
  if (
    /Safari/i.test(uA) &&
    /Apple Computer/.test(vendor) &&
    !/Mobi|Android/i.test(uA)
  ) {
    return true;
  }
  return false;
};

export const isBrowserIE11 = () => {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');
  // eslint-disable-next-line
  if (msie > 0 || !!navigator.userAgent.match(/Trident.*rv\:11\./)) {
    return true;
  }

  return false;
};
